import { HttpErrorResponse } from '@angular/common/http';

export function hasErrorResponseText(res: HttpErrorResponse): boolean {
  return (
    res instanceof HttpErrorResponse && ((res.status !== 500 && res.status !== 513) || (res.error && Object.keys(res.error).length > 0))
  );
}
